module.exports = __webpack_public_path__ + "img/header-engagementRingsTensionRing@2x.2b0b223.webp";